import { render, staticRenderFns } from "./calendario.vue?vue&type=template&id=2a7a342a"
import script from "./calendario.vue?vue&type=script&lang=js"
export * from "./calendario.vue?vue&type=script&lang=js"
import style0 from "./calendario.vue?vue&type=style&index=0&id=2a7a342a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports